const PARTNER_DEFAULT_SHIP_MODAL_TYPE = 'Partner Default';
const RAQ_MODAL_TYPES = ['raq', 'lcw raq'];
const CALL_NOW_MODAL_TYPES = ['call now'];

const isShipTour = (tour) => !!(tour && tour.isShipTour);

const getModalType = (modalTypes, tour, modalSettings) =>
  modalTypes.includes(
    String(
      isShipTour(tour) && modalSettings?.shipModalType !== PARTNER_DEFAULT_SHIP_MODAL_TYPE
        ? modalSettings?.shipModalType
        : modalSettings?.modalType || ''
    ).toLowerCase()
  );

export const isRaqCtaVisible = (tour, modalSettings, areDealsAvailable = true) =>
  areDealsAvailable && getModalType(RAQ_MODAL_TYPES, tour, modalSettings);

export const isCallNowCtaVisible = (tour, modalSettings, noDealsAvailable = false) =>
  noDealsAvailable || getModalType(CALL_NOW_MODAL_TYPES, tour, modalSettings);

export const getComputedPhoneNumber = (isCallNowCta, tour, callNowModal) =>
  isCallNowCta
    ? isShipTour(tour)
      ? callNowModal?.shipCallNowPhoneNumber || ''
      : callNowModal?.callNowPhoneNumber || ''
    : '';
